// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_e1B","cls2":"Unibrow-cls2_4NU Unibrow-cls1_e1B"};